import { render, staticRenderFns } from "./caminhoes.vue?vue&type=template&id=03c94a0a&"
import script from "./caminhoes.vue?vue&type=script&lang=js&"
export * from "./caminhoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports